module.exports = __webpack_public_path__ + "img/info.f63d7524.svg";